export { default } from './CoverDivider';
